module.exports = __webpack_public_path__ + "img/Medicos.5f081e55.svg";